/* eslint-disable max-len */
import React from 'react';

export const UnexpectedErrorOneSVG = () => (
  <svg
    width="240"
    height="250"
    viewBox="0 0 240 250"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Unexpected error illustration"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M185.652 215.895H7.19754C6.89918 213.04 6.93404 210.082 7.33455 207.006C7.35563 206.846 7.37509 206.686 7.39455 206.526C8.73389 195.308 5.89062 184.181 15.7655 175.262C17.661 173.55 20.004 171.871 20.3397 169.631C20.6129 167.803 19.4641 166.054 18.4685 164.384C11.3388 152.416 10.8653 138.654 13.1176 125.587C15.1112 114.024 19.6943 101.962 31.0747 94.3317C49.7405 81.8165 80.3655 86.5567 98.1029 99.8581C113.557 111.448 121.457 126.478 125.808 144.143C126.498 146.943 129.809 148.259 132.365 146.758C142.684 140.698 155.636 138.777 167.331 141.824C178.683 144.781 188.601 152.345 194.392 162.149C201.721 174.556 200.66 186.451 194.812 199.3C192.204 205.031 189.132 210.583 185.652 215.895Z"
      fill="#47C2BB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M75.4268 188.187C75.7494 207.478 81.5268 202.873 81.5268 202.873C81.5284 196.78 86.4699 191.839 92.5651 191.839C98.661 191.839 103.603 196.78 103.603 202.875L104.319 225.558C104.349 226.503 105.124 227.254 106.07 227.254H107.077C108.008 227.254 108.777 226.525 108.826 225.596L109.765 208.002C109.765 199 117.122 191.715 126.154 191.833C121.318 185.157 75.4268 188.187 75.4268 188.187Z"
      fill="#F6915A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M109.899 170.398L111.667 129.295C112.085 117.162 102.35 107.103 90.2022 107.125C78.4448 107.147 68.9802 116.788 68.8027 128.542C68.3203 160.502 74.8646 213.232 76.8517 228.425C76.966 229.298 77.7087 229.948 78.5875 229.948H79.9001C80.8665 229.948 81.6513 229.165 81.6513 228.198V208.115C81.6513 199.227 88.7226 191.819 97.6108 191.704C106.642 191.587 114 198.871 114 207.873V228.198C114 229.165 114.784 229.948 115.752 229.948H118.411C119.378 229.948 120.162 229.165 120.162 228.198V202.747C120.162 196.652 125.104 191.711 131.2 191.711C137.295 191.711 142.237 196.651 142.238 202.745L142.241 225.631C142.241 226.598 143.025 227.381 143.993 227.381H144.969C145.892 227.381 146.656 226.666 146.717 225.746C147.052 220.62 148.059 196.673 148.333 178.628C148.402 174.102 144.748 170.398 140.22 170.398H109.899Z"
      fill="#FFCC66"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M140.522 153.164L136.317 151.027C136.764 145.98 137.215 139.837 137.462 133.541C145.227 132.208 150.902 125.064 150.112 116.942L148.147 96.7288L140.188 98.0127L136.325 107.436C133.183 100.881 127.608 101.607 127.608 101.607L96.151 105.666C95.4772 104.722 95.0751 104.187 95.0751 104.187C88.1643 110.705 83.7701 118.971 80.9933 126.402C78.2473 133.752 81.4644 141.304 87.3958 144.938C86.6053 150.653 85.9413 156.449 85.54 161.903C84.7471 172.698 93.2501 181.91 104.077 181.93C108.692 181.938 113.19 181.666 117.176 181.384V230.096L132.912 223.27L151.667 190.027C159.125 176.808 154.056 160.04 140.522 153.164Z"
      fill="#1B566B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M120.173 137.569C119.377 139.986 117.718 141.649 115.798 141.649C113.104 141.649 110.92 138.374 110.92 134.334C110.92 130.293 113.104 127.018 115.798 127.018C115.928 127.018 116.055 127.028 116.181 127.043C116.542 126.864 116.915 126.694 117.299 126.53C116.817 126.346 116.314 126.248 115.798 126.248C114.229 126.248 112.776 127.131 111.708 128.733C110.703 130.24 110.149 132.229 110.149 134.334C110.149 136.438 110.703 138.427 111.708 139.933C112.776 141.536 114.229 142.419 115.798 142.419C117.367 142.419 118.82 141.536 119.888 139.933C120.425 139.129 120.828 138.185 121.091 137.161C120.778 137.29 120.473 137.425 120.173 137.569Z"
      fill="#FFCC66"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M121.69 82.7697C121.69 82.7697 122.977 81.9259 123.528 80.9702C123.99 80.1702 121.775 75.3789 121.775 75.3789C119.34 69.2567 115.635 65.5532 110.206 66.4424C104.126 67.4378 101.964 73.3006 103.202 80.8551C104.44 88.4096 112.062 93.5713 116.875 92.7834C120.671 92.1609 121.258 88.2953 121.69 82.7697Z"
      fill="#FFBE9D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M109.832 105.31C106.517 104.019 105.593 98.1256 104.833 96.421L105.352 74.7407L113.004 86.2937L114.583 96.9875C117.134 97.5104 119.321 98.1223 121.215 98.8202C123.09 100.302 122.755 101.988 122.88 102.293C123.762 104.45 114.304 107.052 109.832 105.31Z"
      fill="#FFBE9D"
    />
    <mask
      id="mask0_1593_6755"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="93"
      y="58"
      width="33"
      height="32"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.2939 58.5737H125.052V89.2847H93.2939V58.5737Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1593_6755)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.9322 67.6362C95.787 59.7672 110.23 55.4031 113.473 61.3113C113.742 61.8009 114.354 61.9735 114.832 61.685C120.216 58.4427 126.851 60.3751 124.601 66.3109C122.37 72.1948 115.988 71.4515 111.786 69.2305C111.437 69.0457 111.027 69.3189 111.051 69.7136C111.3 73.927 108.666 75.4403 107.216 75.9518C106.655 76.1504 106.305 76.7137 106.379 77.3046C106.611 79.1559 107.509 82.489 110.983 80.555C111.211 80.4277 111.486 80.6093 111.473 80.8703C111.306 84.3079 107.993 85.5845 106.2 83.7048C105.271 86.7185 105.015 89.2848 105.015 89.2848C103.731 84.4084 100.907 85.1784 96.2856 81.5844C91.966 78.2262 92.3568 72.1778 97.2464 69.3051C97.822 68.9671 98.1074 68.2789 97.9322 67.6362Z"
        fill="#D8E5E9"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M103.159 88.7832C104.091 89.0491 105.367 89.302 106.696 89.2322C107.479 89.1917 108.057 88.48 107.91 87.71C107.723 86.7316 107.36 85.3577 106.666 84.1216C106.25 83.3791 105.224 83.2389 104.631 83.8501C103.709 84.8009 102.93 85.9924 102.404 86.8962C101.981 87.6225 102.351 88.553 103.159 88.7832Z"
      fill="#FFCC66"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M125.297 70.3282C123.383 70.3282 121.831 72.5337 121.831 75.2548C121.831 75.3456 121.838 75.4356 121.841 75.5255C121.844 75.5328 121.849 75.5442 121.853 75.5523H120.288C120.289 75.5101 120.291 75.4672 120.291 75.4242C120.291 72.2346 118.337 69.6489 115.926 69.6489C113.515 69.6489 111.562 72.2346 111.562 75.4242C111.562 78.6138 113.515 81.1995 115.926 81.1995C118.106 81.1995 119.911 79.0855 120.238 76.3231H122.192C122.537 77.128 123.019 78.3098 123.318 79.2955C123.879 79.8523 124.561 80.1806 125.297 80.1806C127.211 80.1806 128.763 77.9751 128.763 75.2548C128.763 72.5337 127.211 70.3282 125.297 70.3282Z"
      fill="#103540"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M129.863 139.978H120.451L119.18 120.65H131.135L129.863 139.978Z"
      fill="#F4F8FA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M130.214 134.637L130.95 123.448H119.363L120.099 134.637H130.214Z"
      fill="#C962A5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M131.506 120.9C131.469 120.718 131.31 120.588 131.125 120.588H130.92V120.105C130.92 119.649 130.549 119.279 130.092 119.279H120.223C119.765 119.279 119.395 119.649 119.395 120.105V120.588H119.19C119.004 120.588 118.845 120.718 118.809 120.9L118.609 121.897H131.705L131.506 120.9Z"
      fill="#6A707A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M128.168 128.351C128.153 128.308 128.138 128.264 128.122 128.221C127.162 125.535 124.427 124.067 121.807 124.744C119.819 125.258 118.055 126.038 116.533 126.905C114.753 131.906 116.754 136.288 118.907 138.442C120.496 137.328 122.372 136.338 124.523 135.732C127.534 134.885 129.233 131.472 128.168 128.351Z"
      fill="#FFBE9D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M153.654 228.158L144.082 223.387C139.825 221.425 136.208 217.499 138.776 212.507L117.21 210.055L117.176 230.077H128.729H142.884H154.437V229.381C154.437 228.855 154.131 228.378 153.654 228.158Z"
      fill="#FFBE9D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M153.654 228.158L144.082 223.387C143.927 223.315 143.775 223.242 143.622 223.165C141.31 224.198 138.794 224.894 136.148 225.191L132.528 223.387C132.374 223.315 132.221 223.242 132.069 223.165C128.928 224.568 125.413 225.354 121.702 225.354C120.496 225.354 118.368 225.267 117.21 225.106L117.176 230.077H128.729H142.884H154.437V229.381C154.437 228.856 154.131 228.378 153.654 228.158Z"
      fill="#103541"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M117.176 214.746C118.441 215.424 120.063 215.831 121.831 215.831C124.46 215.831 126.763 214.931 128.054 213.581C129.241 214.787 131.186 215.574 133.384 215.574C135.217 215.574 136.871 215.026 138.06 214.145L151.667 190.028C159.125 176.808 154.056 160.039 140.522 153.163L136.317 151.027L126.361 151.066C113.357 151.117 101.083 157.08 93.0077 167.271C90.4466 170.503 90.4815 175.159 93.2501 178.215C93.4901 178.481 93.7504 178.731 94.0277 178.965C94.8562 179.501 95.7318 179.97 96.6455 180.371C97.1782 180.524 97.6841 180.724 98.1641 180.958C100.017 181.583 102.004 181.926 104.077 181.929C108.692 181.938 113.19 181.666 117.176 181.385V214.746Z"
      fill="#103540"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M98.3401 100.323L94.2604 103.104C93.2746 103.776 92.6892 104.899 92.7014 106.092C92.8343 118.633 94.3812 124.675 100.553 132.337C101.102 133.019 102.162 132.94 102.613 132.189C109.167 121.265 109.637 111.873 109.637 111.873L98.3401 100.323Z"
      fill="#C962A5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M103.412 95.0454C105.88 95.8827 112.973 97.649 123.412 94.9328C123.851 94.8185 124.258 95.2019 124.171 95.6461L123.708 98.0113H128.209C128.993 98.0113 129.628 98.6468 129.628 99.4306V100.32C131.497 100.322 133.008 101.881 132.907 103.746C132.512 111.07 123.057 121.952 113.231 116.494C103.156 110.898 98.6016 104.111 96.7969 100.61C96.2456 99.5408 97.0223 98.2699 98.2247 98.2699H100.393L101.909 95.6185C102.209 95.0932 102.839 94.8509 103.412 95.0454Z"
      fill="#EF5489"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M129.628 100.32V99.4306C129.628 98.6468 128.992 98.0113 128.209 98.0113H123.708L124.171 95.6461C124.257 95.2019 123.85 94.8185 123.411 94.9328C112.973 97.649 105.879 95.8827 103.412 95.0454C102.838 94.8509 102.208 95.0932 101.908 95.6185L100.393 98.2699L99.9489 99.0472C99.6068 99.6446 99.7665 100.403 100.322 100.812C104.02 103.537 117.779 112.198 129.628 100.32Z"
      fill="#C962A5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M151.218 106.514C150.846 105.535 149.99 104.527 148.818 103.626L148.922 104.71C150.304 105.941 150.97 107.275 150.521 108.255C150.147 109.073 149.069 109.487 147.643 109.487C146.305 109.487 144.661 109.123 143.002 108.391C139.575 106.881 137.386 104.369 138.11 102.782C138.184 102.622 138.286 102.478 138.41 102.348L138.911 101.127C138.199 101.411 137.685 101.862 137.41 102.462C137.132 103.072 137.133 103.784 137.414 104.523C138.047 106.188 140.07 107.941 142.692 109.097C144.388 109.844 146.146 110.257 147.643 110.257C149.455 110.257 150.726 109.659 151.222 108.575C151.5 107.966 151.499 107.253 151.218 106.514Z"
      fill="#FFCC66"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M150.112 108.259C149.841 107.864 149.516 107.473 149.154 107.089L149.285 108.428C150.26 109.729 150.613 110.994 150.098 111.873C149.687 112.573 148.793 112.914 147.63 112.914C146.076 112.914 144.042 112.305 142.048 111.136C138.562 109.094 136.513 106.111 137.472 104.475C137.518 104.397 137.571 104.325 137.629 104.257L138.152 102.981C137.559 103.221 137.098 103.592 136.807 104.085C135.595 106.153 137.68 109.47 141.658 111.801C143.7 112.997 145.877 113.683 147.63 113.683C149.113 113.683 150.225 113.179 150.762 112.262C151.385 111.199 151.154 109.777 150.112 108.259Z"
      fill="#FFCC66"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M144.078 99.6955H135.703C134.967 99.6955 134.476 99.099 134.606 98.3638L137.69 80.8774C137.82 80.1414 138.521 79.5457 139.256 79.5457H147.632C148.368 79.5457 148.859 80.1414 148.73 80.8774L145.646 98.3638C145.516 99.099 144.814 99.6955 144.078 99.6955Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M146.571 83.6529C146.074 83.6529 145.743 83.2501 145.83 82.7548L146.057 81.4709C146.144 80.9748 146.618 80.5728 147.114 80.5728C147.610 80.5728 147.942 80.9748 147.854 81.4709L147.628 82.7548C147.540 83.2501 147.067 83.6529 146.571 83.6529Z"
      fill="#6A707A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M148.796 97.1751C148.068 98.5547 146.465 100.279 144.894 101.135C143.152 102.084 140.983 101.213 140.308 99.3474C138.558 94.5156 135.808 89.4747 141.905 87.5228C144.795 86.598 147.024 88.7079 148.418 90.723C149.741 92.6351 149.882 95.1187 148.796 97.1751Z"
      fill="#FFBE9D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M140.189 98.0126L138.284 102.657C139.019 103.69 139.995 104.598 141.187 105.287C143.736 106.759 146.666 106.879 149.035 105.857L148.148 96.7295L140.189 98.0126Z"
      fill="#FFBE9D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M233 137.321V132.916C233 132.916 189.621 130.33 135.258 132.916V137.321H181.912V221.298C175.649 222.559 158.262 223.892 158.262 228.532C158.262 230.607 169.843 232.29 184.129 232.29C198.416 232.29 209.996 230.607 209.996 228.532C209.996 223.892 192.609 222.559 186.346 221.298V137.321H233Z"
      fill="#F6915A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.385 121.884H174.817L172.896 107.669C172.607 105.53 170.761 103.917 168.601 103.917C166.442 103.917 164.596 105.53 164.306 107.669L162.385 121.884ZM175.992 122.911H161.21L163.289 107.532C163.646 104.885 165.93 102.89 168.601 102.89C171.272 102.89 173.556 104.885 173.913 107.532L175.992 122.911Z"
      fill="#422727"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M182.685 132.537H154.516C153.725 132.537 153.152 131.781 153.367 131.019L157.83 115.182C157.974 114.668 158.443 114.312 158.978 114.312H178.223C178.758 114.312 179.227 114.668 179.372 115.182L183.834 131.019C184.049 131.781 183.477 132.537 182.685 132.537Z"
      fill="#5E3A30"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M168.601 122.783C173.63 122.783 177.869 119.421 179.203 114.824C178.984 114.509 178.622 114.312 178.223 114.312H158.979C158.580 114.312 158.218 114.509 158 114.824C159.333 119.421 163.573 122.783 168.601 122.783Z"
      fill="#422727"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M168.601 125.349C167.75 125.349 167.061 124.66 167.061 123.809V122.269C167.061 121.419 167.75 120.729 168.601 120.729C169.451 120.729 170.141 121.419 170.141 122.269V123.809C170.141 124.66 169.451 125.349 168.601 125.349Z"
      fill="#FFCC66"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.1084 245.379H24.2858C24.0775 245.379 23.8902 245.254 23.8107 245.061L20.8856 237.949L18.4914 237.496L16.1516 244.352H17.491C17.7747 244.352 18.005 244.582 18.005 244.866C18.005 245.149 17.7747 245.379 17.491 245.379H15.4341C15.2687 245.379 15.1131 245.299 15.0166 245.164C14.9201 245.03 14.895 244.856 14.9485 244.7L17.6637 236.743C17.7464 236.501 17.9928 236.354 18.245 236.405L21.3501 236.992C21.5204 237.025 21.6639 237.141 21.7296 237.301L24.6296 244.352H26.1084C26.3921 244.352 26.6216 244.582 26.6216 244.866C26.6216 245.149 26.3921 245.379 26.1084 245.379Z"
      fill="#F6915A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4567 219.989C11.7988 225.905 12.6071 230.898 14.3113 234.861C16.9105 240.905 24.4026 242.74 29.5346 239.056C31.0734 239.937 32.4979 240.718 33.9572 241.26C36.4754 242.194 39.2619 242.09 41.7525 241.084L44.8666 241.252C45.1836 241.27 45.3189 240.856 45.0538 240.683L13.4567 219.989Z"
      fill="#697079"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7929 233.929C19.5514 236.238 22.8746 236.631 25.1415 234.818C26.9243 233.392 27.564 230.967 26.7159 228.847L26.6154 228.595L13.457 219.989C13.6135 226.811 15.7377 231.23 17.7929 233.929Z"
      fill="#5A6066"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.0531 240.683L42.4198 238.958L41.2734 239.556L41.7518 241.085L44.8667 241.252C45.1828 241.269 45.3182 240.856 45.0531 240.683Z"
      fill="#F6915A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.7288 239.934C42.4961 240.185 42.274 240.474 41.9691 240.6C41.7405 240.694 41.4867 240.685 41.2621 240.604C40.8519 240.457 40.5284 240.027 40.5665 239.555C40.599 239.153 40.8811 238.795 41.2224 238.61C41.5637 238.424 41.9545 238.389 42.3267 238.418C42.6112 238.44 42.899 238.5 43.139 238.656C43.3595 238.798 43.6701 239.118 43.4909 239.408C43.3774 239.593 42.9071 239.741 42.7288 239.934Z"
      fill="#9870B1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M73.6058 245.379H71.5489C71.266 245.379 71.0357 245.149 71.0357 244.866C71.0357 244.582 71.266 244.352 71.5489 244.352H72.8883L70.5404 237.471L66.6066 237.968L63.6896 245.061C63.6101 245.254 63.422 245.379 63.2145 245.379H61.3919C61.1082 245.379 60.8779 245.149 60.8779 244.866C60.8779 244.582 61.1082 244.352 61.3919 244.352H62.8707L65.77 237.301C65.8405 237.13 65.997 237.01 66.181 236.987L70.8266 236.399C71.0706 236.369 71.2984 236.512 71.3771 236.743L74.0914 244.7C74.1457 244.856 74.1198 245.03 74.0233 245.164C73.9268 245.299 73.7712 245.379 73.6058 245.379Z"
      fill="#F6915A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M64.5596 225.658C63.9426 225.853 63.2721 225.59 62.9527 225.027L60.5367 220.768C59.1982 218.427 56.2924 217.495 53.8416 218.62L50.9099 219.968L49.3152 220.708C48.8417 220.927 48.9982 221.637 49.5195 221.637H51.8625L58.5941 233.425C62.1322 239.616 70.8161 240.374 75.2963 234.828C78.0074 231.471 80.134 226.881 80.134 220.738L64.5596 225.658Z"
      fill="#697079"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.9101 219.967L49.3145 220.708C48.8419 220.927 48.9984 221.636 49.5197 221.636H51.8627L52.8429 220.142L52.0873 219.427L50.9101 219.967Z"
      fill="#F6915A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.019 225.512L64.9882 225.553C63.6043 227.369 63.5718 229.877 64.9088 231.727C66.6081 234.08 69.9151 234.589 72.2273 232.834C74.9028 230.804 78.0923 227.166 80.0721 220.757L65.019 225.512Z"
      fill="#5A6066"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.0031 220.403C52.1434 220.716 52.2609 221.059 52.5098 221.277C52.6963 221.439 52.9395 221.512 53.1779 221.508C53.6149 221.499 54.0584 221.195 54.1735 220.735C54.2708 220.344 54.1175 219.914 53.8532 219.629C53.5897 219.345 53.2306 219.187 52.869 219.095C52.5917 219.026 52.3007 218.991 52.0234 219.06C51.7688 219.124 51.3716 219.329 51.4494 219.661C51.498 219.872 51.8953 220.164 52.0031 220.403Z"
      fill="#9870B1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.9393 244.609C48.4431 244.609 48.041 245.012 48.041 245.507V246.406H49.8376V245.507C49.8376 245.012 49.4355 244.609 48.9393 244.609Z"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.7905 248.973C52.4363 248.973 52.1484 249.26 52.1484 249.615V250H53.4327V249.615C53.4327 249.26 53.1448 248.973 52.7905 248.973Z"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.5954 246.919C40.1698 246.919 39.8252 247.264 39.8252 247.689V247.946H41.3656V247.689C41.3656 247.264 41.021 246.919 40.5954 246.919Z"
      fill="#B26E4B"
    />
  </svg>
);
